export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-light-c276222e410a3f9ebdbe18057fe883fb.eot";